import React, {useState} from 'react';
import {useFormContext} from 'react-hook-form';
import {useSelector} from 'react-redux';
import {i18n} from 'src/i18n';
import selectors from 'src/modules/gestorDocumental/gestorDocumentalSelectors';
import GestorDocumentalService from 'src/modules/gestorDocumental/gestorDocumentalService';
import AutocompleteInMemoryFormItem from 'src/view/shared/form/items/AutocompleteInMemoryFormItem';
import GestorDocumentalFormModal from 'src/view/gestorDocumental/form/GestorDocumentalFormModal';

function GestorDocumentalDocumentoPrincipalFormItem(props) {
  const {setValue, getValues} = useFormContext();

  const [modalVisible, setModalVisible] = useState(false);

  const hasPermissionToCreate = useSelector(selectors.selectPermissionToCreate);

  const doCloseModal = () => {
    setModalVisible(false);
  };

  const doOpenModal = () => {
    setModalVisible(true);
  };

  const doCreateSuccess = (record) => {
    const {name, mode} = props;

    if (mode && mode === 'multiple') {
      setValue(name, [...(getValues()[name] || []), record], {shouldValidate: true, shouldDirty: true});
    } else {
      setValue(name, record, {
        shouldValidate: true,
        shouldDirty: true,
      });
    }

    doCloseModal();
  };

  const fetchFn = (value, limit) => {
    // Añadimos un filtro para evitar seleccionar el documento actual o documentos que ya tienen este como principal
    return GestorDocumentalService.listAutocomplete(value, limit);
  };

  const mapper = {
    toAutocomplete(originalValue) {
      if (!originalValue) {
        return null;
      }

      const value = originalValue.id;
      let label = originalValue.label;

      if (originalValue.nombre) {
        label = originalValue.nombre;
      }

      return {
        key: value,
        value,
        label,
      };
    },

    toValue(originalValue) {
      if (!originalValue) {
        return null;
      }

      return {
        id: originalValue.value,
        label: originalValue.label,
      };
    },
  };

  return (
    <>
      <AutocompleteInMemoryFormItem
        {...props}
        fetchFn={fetchFn}
        mapper={mapper}
        onOpenModal={doOpenModal}
        hasPermissionToCreate={hasPermissionToCreate}
        noLink
      />

      {modalVisible && (
        <GestorDocumentalFormModal 
          onClose={doCloseModal} 
          onSuccess={doCreateSuccess}
          // Pasamos un filtro para que en el formulario de creación no se pueda seleccionar
          // a sí mismo como documento principal
          filterDocumentoPrincipal={true}
        />
      )}
    </>
  );
}

export default GestorDocumentalDocumentoPrincipalFormItem;